import { Axios } from "../../../util";
import { saveAs } from 'file-saver';
const downloadReceiptFileAPI = async (policyNo, receiptNo) => {
  try {
    // const res = await Axios.post("/api/policy/policyInformation");
    const res = await Axios.get(
      `/api/policy/policyReceipt?policyNo=${policyNo}&receiptNo=${receiptNo}`,
    );
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};

const getPolicyReceiptYear = async (policyNo, insureIdCard) => {
  try {
    const res = await Axios.get(
      `/api/policy/getPolicyReceiptYears?policyNo=${policyNo}&insureIdCard=${insureIdCard}`,
    );
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
}

const downloadReceiptFilePDFAPI = async (listData) => {
  try {
    const res = await Axios.post(
        `/api/policy/policyReceiptPDF`,
        listData,
        {
          responseType: 'arraybuffer', // <-- สำคัญมาก
        }
    );

    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('th-TH', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });

    const blob = new Blob([res.data], { type: 'application/pdf' });
    saveAs(blob, 'รายละเอียดการชำระเบี้ยประกัน วันที่ '+formattedDate+'.pdf');
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};


export { downloadReceiptFileAPI,
         getPolicyReceiptYear,
  downloadReceiptFilePDFAPI
 };
